const countryDetailsToast = (state = null, action) => {
  if (action.type === "SET_COUNTRY_DETAILS_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_COUNTRY_DETAILS_TOAST": {
  //     return action.payload;
  //   }
  //   default: {
  //     return state;
  //   }
  // }
};

export default countryDetailsToast;
